var React = require('react');

function CreditCard (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1696 128q66 0 113 47t47 113v1216q0 66-47 113t-113 47H96q-66 0-113-47t-47-113V288q0-66 47-113t113-47h1600zM96 256q-13 0-22.5 9.5T64 288v224h1664V288q0-13-9.5-22.5T1696 256H96zm1600 1280q13 0 22.5-9.5t9.5-22.5V896H64v608q0 13 9.5 22.5T96 1536h1600zM192 1408v-128h256v128H192zm384 0v-128h384v128H576z"}));
}

CreditCard.defaultProps = {"width":"1792","height":"1792","viewBox":"0 0 1792 1792"};

module.exports = CreditCard;

CreditCard.default = CreditCard;
